<template>
  <el-dialog
    :title="type==='add'?'新增分类':type==='edit'?'编辑分类':'增加子类'"
    :visible.sync="visible"
    width="500px"
    :before-close="handleClose"
    custom-class="fabric-dialog"
>
    <div>
      <el-form :model="formData" ref="refForm" :rules="rules" label-width="100px" class="demo-dynamic">
        <el-form-item label="中文名称" prop="cnName">
          <el-input v-model="formData.cnName" @blur="handleBlur('cnName')"></el-input>
        </el-form-item>
        <el-form-item label="英文名称" prop="enName">
          <el-input v-model="formData.enName" @blur="handleBlur('enName')"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <el-button size="small" type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import API from '@/api'
export default {
  data() {
    return {
      visible: false,
      type: 'add',
      formData: {
        cnName: undefined,
        enName: undefined
      },
      rules: {
        cnName: [
          { required: true, message: '请输入中文名称', trigger: 'blur' }
        ],
        enName: [
          { required: true, message: '请输入英文名称', trigger: 'blur' },
          { pattern: /([a-zA-Z])/g, message: '请输入正确的英文名称', trigger: 'blur' },
        ]
      }
    }
  },
  methods: {
    show(type, row) {
      this.type = type
      if (type === 'edit') {
        this.$set(this.formData, 'cnName', row.languageList[1].name)
        this.$set(this.formData, 'cnId', row.languageList[1].id)
        this.$set(this.formData, 'enName', row.languageList[0].name)
        this.$set(this.formData, 'enId', row.languageList[0].id)
        this.$set(this.formData, 'id', row.id)
      } else if (type === 'subclass') {
        this.$set(this.formData, 'parentId', row.id)
      }
      this.visible = true
    },
    handleClose() {
      this.formData = {
        cnName: undefined,
        enName: undefined
      }
      this.visible = false
    },
    handleConfirm() {
      this.$refs.refForm.validate(valid => {
        if (valid) {
          let params = {
            id: this.formData.id || undefined,
            parentId: this.formData.parentId || undefined,
            languageList: [
              { languageId: 1, name: this.formData.enName, id: this.formData.enId || undefined },
              { languageId: 2, name: this.formData.cnName, id: this.formData.cnId || undefined },
            ]
          }
          API.editFabricCategory(params).then(res => {
            if (res.code !== 10000) return this.$message.error(res.message)
            this.$message.success('操作成功')
            this.$emit('confirm')
            this.handleClose()
          })
        }
      })
    },
    handleBlur(type) {
      this.$nextTick(() => {
        let value = this.formData[type].trim()
        this.$set(this.formData, type, value.replace(/\s+/g, ' '))
      })
    }
  }
}
</script>

<style lang="scss">
.fabric-dialog {
  .el-dialog__body {
    padding: 20px 20px 10px 20px ;
  }
}
</style>
<style lang="scss" scoped>
</style>